import React from 'react';
import Sidebar from '../Sidebar';
import { Flex } from 'rebass';
import PropTypes from 'prop-types';
import { SIDEBAR_COLLAPSED_WIDTH } from '@/components/Sidebar/Sidebar';

type LayoutProps = {
  children?: React.ReactNode;
};

/**
 * @component for page layout
 */
const Layout = (props: LayoutProps): JSX.Element => {
  return (
    <Flex sx={{ height: '100vh', overflow: 'hidden' }}>
      <Sidebar />
      <Flex
        as="main"
        flexDirection="column"
        bg="background"
        color="text"
        sx={{
          flexGrow: 1,
          flexShrink: 1,
          minWidth: 0,
          // height: '100vh',
          overflow: 'auto',
          background: 'linear-gradient(0deg, #fff, #fafafa, #f1f1f1);',
          // on mobile the sidebar is a fixed strip, offset content to clear it
          ml: [SIDEBAR_COLLAPSED_WIDTH, SIDEBAR_COLLAPSED_WIDTH, 0],
        }}
      >
        {props.children}
      </Flex>
    </Flex>
  );
};

Layout.propTypes = {
  children: PropTypes.node,
};

export default Layout;
